import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashAccountSearchResponse from "../CashAccountSearchResponse";
import ModelProxyClass from "./ModelProxyClass";
import CashAccount from "../CashAccount";


/**
 * @class CashAccountSearchResponseBase
 * @extends ModelBaseClass
 * @property {[CashAccount]} cashAccounts
 * @property {number} totalItemCount (int64)
 */
class CashAccountSearchResponseBase extends ModelBaseClass {
	/**
	 * @type {[CashAccount]} cashAccounts
	 */
	cashAccounts;
	/**
	 * @type {number} totalItemCount (int64)
	 */
	totalItemCount;

	/**
	 * Instantiates a new instance of CashAccountSearchResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashAccountSearchResponse}
	 */
	static create(genericObject) {
		const newCashAccountSearchResponse = new CashAccountSearchResponse();
		newCashAccountSearchResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashAccountSearchResponse;
	}

	/**
	 * Instantiates a new array of CashAccountSearchResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashAccountSearchResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashAccountSearchResponseArray = [];
		genericArray.forEach(genericObject => {
			newCashAccountSearchResponseArray.push(CashAccountSearchResponse.create(genericObject));
		});
		return newCashAccountSearchResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashAccounts', '[CashAccount]'),
	ModelBaseClass.createModelProperty('totalItemCount', 'integer'),
];

export default CashAccountSearchResponseBase;
